export const selectTaxesContent = propertyCode => state => state.taxes?.data[propertyCode];
